export const spinRing = (
  <g>
    <circle
      id="spin-ring-jurisdiction"
      cx="150"
      cy="150"
      r="145"
      fill="transparent"
      strokeDasharray="911.06"
      strokeDashoffset="0"
    ></circle>
  </g>
)